import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductCustomPage } from '@/features/custom-pages'

export const Route = createFileRoute('/_event/p/$slug')({
  component: DigitalProductCustomPageRoute
})

function DigitalProductCustomPageRoute() {
  const { slug } = Route.useParams()

  return <DigitalProductCustomPage slug={slug} />
}
